export default {
    title: 'Auswertungen',

    noReportsToUse: 'Für die ausgewählten Maßnahmen sind keine Auswertungen verfügbar.',

    report: 'Auswertung',
    reportFormType: 'Formulartyp',
    maxProcessesForReporting: 'Es werden nur die ersten 1000 Maßnahmen berücksichtigt.',
    reportNotAvailableForProcesses: 'Die Auswertung ist für die folgenden Maßnahmen nicht verfügbar: {processes}.',
    reportWillNotBeCreatedFor: 'Diese Maßnahmen werden bei dieser Auswertung nicht berücksichtigt.',
    showNewStatusSelection: 'Neuen Status setzen',
    showNewStatusSelectionHelpText: 'Wenn die Auswertung erzeugt wurde, kann für alle ausgewählten Maßnahmen ein neuer Status gesetzt werden.',
    newStatus: 'Neuer Status',
    statusNotAvailableForProcesses: 'Der Status ist für die folgenden Maßnahmen nicht verfügbar: {processes}.',
    statusWillNotBeChanged: 'Der Status dieser Maßnahme wird nicht geändert.',
    usePersonalSignature: 'Persönliche Unterschrift verwenden',
    usePersonalSignatureHelpText: 'Die persönliche Unterschrift, falls vorhanden, wird in die Auswertung eingedruckt.',

    doReport: 'Auswertung erzeugen',

    digitalDocumentsReport: 'Auswertung mit digitalen Dokumenten',
    digitalDocumentsReportHelpText: 'Hier wird die oben ausgewählte Auswertung erzeugt und alle Maßnahmendokumente inklusive den Uploads werden an die Auswertungsliste angehängt.',
    doDigitalDocumentsReport: 'Auswertung mit digitalen Dokumenten erzeugen',

    noReportCreated: 'Es konnte keine Auswertung erzeugt werden.',
    errorOnCreation: 'Fehler beim Erzeugen der Auswertung.',
    errorOnLoad: 'Fehler beim Laden.',
}